import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setToogleHeader } from "../../core/redux/action";
import { ArrowLeft, ChevronDown, ChevronUp } from "feather-icons-react/build/IconComponents";
import { all_routes } from "../../Router/all_routes";
import { renderRequired } from '../../feature-module/common/common.js';

const ManageEnquiry = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);

  // State for enquiry info
  const [formData, setFormData] = useState({
    enqNumber: "", // Auto-generated number
    dateOfEnquiry: new Date().toISOString().split("T")[0], // Current date
    client: null,
    services: [{ service: null, quantity: "" }],
    autoReminderDate: "", // Set later after calculation
  });

  const [errors, setErrors] = useState({});

  const clientOptions = [
    { value: "client1", label: "Client 1" },
    { value: "client2", label: "Client 2" },
  ];

  const serviceOptions = [
    { value: "service1", label: "Service 1" },
    { value: "service2", label: "Service 2" },
  ];

  useEffect(() => {
    // Auto-generate a unique enquiry number
    const uniqueEnqNumber = `ENQ-${Math.floor(Math.random() * 100000)}`;
    setFormData((prevState) => ({
      ...prevState,
      enqNumber: uniqueEnqNumber,
      autoReminderDate: calculateAutoReminder(prevState.dateOfEnquiry),
    }));
  }, []);

  // Calculate reminder date (15 days before one-year anniversary of enquiry)
  const calculateAutoReminder = (dateOfEnquiry) => {
    const reminderDate = new Date(dateOfEnquiry);
    reminderDate.setFullYear(reminderDate.getFullYear() + 1);
    reminderDate.setDate(reminderDate.getDate() - 15);
    return reminderDate.toISOString().split("T")[0];
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.client) newErrors.client = "Client is required";
    formData.services.forEach((service, index) => {
      if (!service.service) newErrors[`service_${index}`] = "Service is required";
      if (!service.quantity) newErrors[`quantity_${index}`] = "Quantity is required";
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSelectChange = (name, index = null) => (selectedOption) => {
    if (index === null) {
      setFormData({ ...formData, [name]: selectedOption });
    } else {
      const updatedServices = [...formData.services];
      updatedServices[index][name] = selectedOption;
      setFormData({ ...formData, services: updatedServices });
    }
  };

  const handleInputChange = (e, index = null) => {
    const { name, value } = e.target;
    if (index === null) {
      setFormData({ ...formData, [name]: value });
    } else {
      const updatedServices = [...formData.services];
      updatedServices[index][name] = value;
      setFormData({ ...formData, services: updatedServices });
    }
  };

  const addServiceRow = () => {
    setFormData({
      ...formData,
      services: [...formData.services, { service: null, quantity: "" }],
    });
  };

  const removeServiceRow = (index) => {
    const updatedServices = formData.services.filter((_, i) => i !== index);
    setFormData({ ...formData, services: updatedServices });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    console.log("Form Data:", formData);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>New Enquiry</h4>
              <h6>Create new enquiry</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <div className="page-btn">
                <Link to={route.employees} className="btn btn-secondary">
                  <ArrowLeft className="me-2" />
                  Back to Enquiry List
                </Link>
              </div>
            </li>
            <li>
              <Link
                className={data ? "active" : ""}
                onClick={() => dispatch(setToogleHeader(!data))}
              >
                {data ? <ChevronUp /> : <ChevronDown />}
              </Link>
            </li>
          </ul>
        </div>

        <form onSubmit={handleSubmit}>
        <div className="card">
              <div className="card-body">
              <div className="row">
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Enquiry Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="enqNumber"
                      value={formData.enqNumber}
                      disabled
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Date of Enquiry {renderRequired()}</label>
                    <input
                      type="date"
                      className="form-control"
                      name="dateOfEnquiry"
                      value={formData.dateOfEnquiry}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Client {renderRequired()}</label>
                    <Select
                      classNamePrefix="react-select"
                      options={clientOptions}
                      placeholder="Select Client"
                      value={formData.client}
                      onChange={handleSelectChange("client")}
                    />
                    {errors.client && <div className="text-danger">{errors.client}</div>}
                  </div>
                </div>
              </div>

              <h5>Services {renderRequired()}</h5>
              {formData.services.map((service, index) => (
                <div className="row" key={index}>
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">Service {renderRequired()}</label>
                      <Select
                        classNamePrefix="react-select"
                        options={serviceOptions}
                        placeholder="Select Service"
                        value={service.service}
                        onChange={handleSelectChange("service", index)}
                      />
                      {errors[`service_${index}`] && <div className="text-danger">{errors[`service_${index}`]}</div>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">Quantity {renderRequired()}</label>
                      <input
                        type="number"
                        className="form-control"
                        name="quantity"
                        value={service.quantity}
                        onChange={(e) => handleInputChange(e, index)}
                      />
                      {errors[`quantity_${index}`] && <div className="text-danger">{errors[`quantity_${index}`]}</div>}
                    </div>
                  </div>
                  <spam className="col-lg-4 col-sm-6 col-12 d-flex justify-content-start align-items-center" style={{color:'$warning'}}><i className="bx bx-x-circle" style={{  fontSize:'20px', justifyContent:'center', borderRadius:'50px', color:"#FF9F43", border: "1px", paddingLeft:'5px'}}   onClick={() => removeServiceRow(index)} /> </spam>
                  {/* <div className="col-lg-4 col-sm-6 col-12">
                      <Trash2 onClick={() => removeServiceRow(index)}/> Remove
                  </div> */}
                </div>
              ))}

              <button type="button" className="btn btn-primary mb-3" onClick={addServiceRow}>
                Add Service
              </button>

              <div className="row">
                <div className="col-lg-4 col-sm-6 col-12">
                  <div className="mb-3 add-product">
                    <label className="form-label">Auto Reminder Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="autoReminderDate"
                      value={formData.autoReminderDate}
                      // disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="submit-section">
            <button className="btn btn-primary" type="submit">
              Submit Enquiry
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManageEnquiry;
